var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcSelect',{staticClass:"categoryMultiSelect",attrs:{"value":_vm.selectedCategoryItem,"aria-label-combobox":_vm.t('cospend', 'Category selector'),"label":"displayName","disabled":_vm.disabled,"clearable":false,"placeholder":_vm.placeholder,"options":_vm.formattedOptions},on:{"input":_vm.onCategorySelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }